import { render } from "./ClientReportesProveedoresDeuda.vue?vue&type=template&id=15d525bc&scoped=true"
import script from "./ClientReportesProveedoresDeuda.vue?vue&type=script&lang=js"
export * from "./ClientReportesProveedoresDeuda.vue?vue&type=script&lang=js"

import "./ClientReportesProveedoresDeuda.vue?vue&type=style&index=0&id=15d525bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d525bc"]])

export default __exports__